import React from 'react';
import { partners } from '../../data/site';
import { EnergyTrace } from '../ui/EnergyTrace';
const facts = [{
  value: '3–4 hrs',
  label: 'Initial setup, All-in-One system'
}, {
  value: '~30 min',
  label: 'Each setup after that'
}, {
  value: 'Remote-tested',
  label: 'Systems tested in remote areas'
}, {
  value: '48 hrs',
  label: 'Response time on every enquiry'
}];
export function ProofBar() {
  return <section aria-label="Partners and key facts" className="bg-white" data-id="element-445" data-mp="3ngco0b8bvftz">
      <div className="mx-auto max-w-page px-5 py-12 lg:px-8" data-id="element-446" data-mp="3iib1fgbp0ydr">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:gap-10" data-id="element-447" data-mp="3ihrlg55lsk2d">
          <p className="shrink-0 text-sm font-medium text-afb-muted" data-id="element-448" data-mp="11093vazm7dt">Trusted by / Working with</p>
          <ul className="grid flex-1 grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5" data-id="element-449" data-mp="3s8crgdnlwqvb">
            {partners.map(partner => <li key={partner.name} data-id="element-450" data-mp="9zve542apbfj">
                {partner.logo ? <img src={partner.logo} alt={partner.name} className="h-14 w-full object-contain grayscale" data-id="element-451" data-mp="54pru44zduqx" /> : <div className="flex h-14 items-center justify-center rounded-lg border border-dashed border-afb-ink/15 bg-afb-light text-xs text-afb-muted" data-id="element-452" data-mp="2pp3b8i7qjx5z">
                    Partner logo supplied
                  </div>}
              </li>)}
          </ul>
        </div>

        <EnergyTrace className="my-10" data-id="element-453" data-mp="33oulq8z1mvf8" />

        <dl className="grid grid-cols-2 gap-y-8 lg:grid-cols-4 lg:divide-x lg:divide-afb-line" data-id="element-454" data-mp="33o2xxkbou1zi">
          {facts.map((fact, index) => <div key={fact.label} className={index === 0 ? 'lg:pr-8' : 'lg:px-8'} data-id="element-455" data-mp="38lkxwl7q96vd" data-mpi={index}>
              <dt className="sr-only" data-id="element-456" data-mp="3dffo87hu8k3f">{fact.label}</dt>
              <dd className="font-sora text-2xl font-semibold tracking-tight text-afb-ink md:text-3xl" data-id="element-457" data-mp="3ie0epf7afpeo">{fact.value}</dd>
              <dd className="mt-1 text-sm text-afb-muted" data-id="element-458" data-mp="3ne4wr9nugs70">{fact.label}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}